<template>
  <v-hover v-slot="{ hover }">
    <div
      class="selectable-extraction-value px-4 white"
      :class="getClasses(hover)"
      @click="$emit('click')"
    >
      <v-text-field
        v-if="editable"
        ref="input"
        v-model="model"
        placeholder="Other"
        class="pt-0 mt-0 subtitle-2"
        hide-details="auto"
      />
      <div
        v-else
        class="my-2 subtitle-2 grey--text userselect-none text--darken-2"
      >
        {{ value }}
      </div>
      <confirm-consensus-chip
        v-if="selected && !hideConfirm"
        :complete="complete"
        :researchers="researchers"
        @click="onConfirm"
      />
      <researcher-avatar-cluster
        v-else-if="hasResearchers"
        :researchers="researchers"
      />
    </div>
  </v-hover>
</template>

<script>
import ConfirmConsensusChip from '@/components/DataExtraction/ConfirmConsensusChip';
import ResearcherAvatarCluster from '@/components/Common/ResearcherAvatarCluster';

export default {
  name: 'SelectableExtractionValue',
  components: { ConfirmConsensusChip, ResearcherAvatarCluster },
  props: {
    value: {
      type: String,
      default: null,
    },
    selected: {
      type: Boolean,
      default: false,
    },
    complete: {
      type: Boolean,
      default: false,
    },
    editable: {
      type: Boolean,
      default: false,
    },
    hideConfirm: {
      type: Boolean,
      default: false,
    },
    researchers: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    model: {
      get: function () {
        return this.value;
      },
      set: function (value) {
        this.$emit('input', value);
      },
    },
    classes() {
      return {};
    },
    hasResearchers() {
      return this.researchers.length > 0;
    },
    emptyValue() {
      return !this.value || this.value.trim() === '';
    },
  },
  watch: {
    selected(focus) {
      if (!this.$refs.input) return;
      focus ? this.$refs.input.focus() : this.$refs.input.blur();
    },
  },
  methods: {
    getClasses(hover) {
      return {
        ['green lighten-4']: this.selected,
        ['green lighten-5']: this.selected && hover,
        ['grey lighten-4']: !this.selected && hover,
      };
    },
    onConfirm() {
      if (this.emptyValue) return;
      this.$emit('confirm');
    },
  },
};
</script>

<style lang="scss" scoped>
.selectable-extraction-value {
  display: grid;
  grid: 'label chip' / 1fr auto;
  grid-gap: 8px;
  align-items: center;
  min-height: 48px;
  cursor: pointer;
}
</style>
